import React from "react";
import StackNavigator from "../../components/StackNavigator";
import Address from "./Address";
import Development from "./Development";
import Profile from "./Profile";

function ProfileScreens() {
  const SCREENS = [
    { name: "profilescreen", component: Profile },
    { name: "addresses", component: Address },
    { name: "develop", component: Development },
  ];
  return <StackNavigator screens={SCREENS} />;
}

export default ProfileScreens;
